/**
 * Create beauty assistant session context for custom hook
 */
import { createContext } from 'react'

const BeautyAssistantSessionContext = createContext({
  fetchBeautyAssistantSession: () => {},
  fetchBeautyAssistantSessionBySlugName: () => {}
})

export default BeautyAssistantSessionContext
